import React from 'react';
import { Link } from 'react-router-dom';
import links from 'utils/links';

/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Welcome from '../../components/welcome';
import Loader from '../../components/Loader';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    // backgroundColor: theme.palette.primary.paper,
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    border: '2px solid #808080',
    borderRadius: '50%',
  },
  gridList: {
    width: '100%',
    height: '100%',
    paddingBottom: '5px',
  },
  mobileList: {
    [theme.breakpoints.down('sm')]: {
      cols: 2,
      rows: 2,
    },
  },
  heading: {
    margin: '20px',
  },
  whiteText: {
    color: 'white',
  },
  bgImage: {
    width: '100%',
    height: '100%',
  },
  media: {
    height: 400,
    background:
      'linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)),url("/img/Thai_Curry_HP_2.jpg")',
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imgContainer: {
    textAlign: 'center',
    color: 'white',
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  imgBody: {
    color: '#ffff',
    padding: '20px',
  },
  top: {
    marginTop: '10px',
    fontSize: '1rem',
  },
  centering: {
    [theme.breakpoints.only('lg')]: {
      maxWidth: '75%',
      marginLeft: 'auto',
      marginRight: 'auto',
      lineHeight: '1.5',
    },
  },
});

class Landing extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  componentDidMount() {
    this.props.dispatch(actions.getData());
  }
  render() {
    const { classes, loading, cities } = this.props;
    if (loading) {
      return <Loader />;
    } else {
      return (
        <div className={classes.root}>
          <Welcome />
          <Grid container>
            <Grid item xs={12} className={classes.ImgContainer}>
              <div className={classes.media}>
                <div className={classes.centered}>
                  <Typography variant="h6" className={classes.imgBody}>
                    TALKING STREET
                  </Typography>
                  <Typography
                    variant="overline"
                    className={[
                      classes.imgBody,
                      classes.top,
                      classes.centering,
                    ].join(' ')}
                  >
                    Talking Street is a community for foodies, by foodies.
                    <br />
                    Discover eateries recommended by locals, read stories by
                    food pundits and experience cuisines and culture first hand,
                    across 35+ Indian destinations.
                  </Typography>
                  <Link to={links.aboutTalkingstreet()}>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.top}
                    >
                      Read more
                    </Button>
                  </Link>
                </div>
              </div>
            </Grid>
          </Grid>
          <Typography className={classes.heading} variant="h5">
            Explore Our Destinations
          </Typography>
          <GridList
            cellHeight={180}
            className={[classes.gridList, classes.mobileList].join(' ')}
          >
            {cities.map((city, i) =>
              city.mainImage.uri ? (
                <GridListTile
                  key={'city' + i}
                  cols={1}
                  rows={2}
                  style={{ height: 'auto' }}
                >
                  <Link to={links.cityHome(city.name)}>
                    <img
                      className={classes.bgImage}
                      src={city.mainImage.uri}
                      alt={city.cityName}
                    />
                    <GridListTileBar
                      title={
                        <Typography
                          className={classes.whiteText}
                          variant="subtitle1"
                        >
                          {city.cityName}
                        </Typography>
                      }
                      subtitle={
                        city.localCuisines.length > 0 ? (
                          <Typography
                            className={classes.whiteText}
                            variant="subtitle2"
                          >
                            Local Cuisines:{' '}
                            {city.localCuisines
                              .map(cuisine => cuisine.name)
                              .join(', ')}
                          </Typography>
                        ) : (
                          ''
                        )
                      }
                    />
                  </Link>
                </GridListTile>
              ) : (
                ''
              )
            )}
          </GridList>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(Landing));
